import { render, staticRenderFns } from "./educationCourseTextBook.vue?vue&type=template&id=74377862"
import script from "./educationCourseTextBook.vue?vue&type=script&lang=js"
export * from "./educationCourseTextBook.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('74377862')) {
      api.createRecord('74377862', component.options)
    } else {
      api.reload('74377862', component.options)
    }
    module.hot.accept("./educationCourseTextBook.vue?vue&type=template&id=74377862", function () {
      api.rerender('74377862', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sop/edu/cc/educationCourseTextBook.vue"
export default component.exports